var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilitySafeOrQuietSpace = function SvgAccessibilitySafeOrQuietSpace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M10.614 28.5c-.027-.806-.325-2.742-2.034-3.822a146 146 0 0 0-4.104-2.501.57.57 0 0 1-.232-.259L2.002 16.94a.6.6 0 0 1-.049-.266l.3-6.054a.572.572 0 0 1 .795-.496c.349.148.721.405.848.84.28.92.618 4.378.618 4.378"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m6.937 21.256-1.03-1.794a.6.6 0 0 0-.14-.176l-.55-.462a.6.6 0 0 1-.104-.114L3.67 16.623a.57.57 0 0 1 .188-.817c.477-.28 1.34-.466 2.632.373 1.63 1.054 2.279 2.061 2.498 2.49.07.133.189.235.332.283.888.292 4.055 1.528 5.649 4.669a.6.6 0 0 1 .06.233l-.02 4.597M7.287 16.695V9.853M19.385 28.5c.027-.806.325-2.742 2.034-3.822a140 140 0 0 1 4.109-2.502.57.57 0 0 0 .232-.259l2.238-4.978a.6.6 0 0 0 .049-.266l-.302-6.053a.572.572 0 0 0-.794-.496c-.349.148-.716.405-.848.84-.28.92-.618 4.378-.618 4.378"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m23.094 21.312 1.03-1.794a.6.6 0 0 1 .14-.177l.55-.461a.6.6 0 0 0 .104-.114l1.443-2.087a.57.57 0 0 0-.143-.795l-.038-.023c-.477-.28-1.34-.466-2.632.373-1.63 1.054-2.279 2.061-2.498 2.489a.57.57 0 0 1-.332.284c-.888.293-4.055 1.529-5.648 4.67M7.271 9.832H5.475a.302.302 0 0 1-.189-.537l1.985-1.588V4.733h3.71m11.912 11.795V9.83h1.904a.299.299 0 0 0 .19-.526l-9.32-7.659a.645.645 0 0 0-.813 0l-3.867 3.092"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 18.212,
    cy: 9.97,
    r: 1.208
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m17.187 20.926-.402-2.924-.765-.992a.78.78 0 0 1-.16-.478l.01-2.783c-.012-.492.282-.95.782-.971h3.222c.5.021.793.48.78.97l.012 2.784a.78.78 0 0 1-.16.478l-.762.992-.178 1.287"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 11.952,
    cy: 10.059,
    r: 1.205
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M12.91 20.852 13.302 18l.76-.99a.78.78 0 0 0 .16-.478l-.011-2.783c.012-.492-.281-.95-.781-.971h-3.222c-.5.021-.794.48-.781.97l-.012 2.784a.78.78 0 0 0 .163.478l.762.992.177 1.287"
  }))));
};
export default SvgAccessibilitySafeOrQuietSpace;